import { createRouter, createWebHistory } from 'vue-router'
import Layout from './views/layout/index.vue'

let routerMap = [
  {
    path: '/login',
    component: () => import('./views/login/index')
  },
  {
    path: '/',
    component: Layout,
    redirect: '/main',
    children: [{
      path: 'main',
      component: () => import('./views/main/index.vue')
    }]
  },
  {
    path: '/article',
    component: Layout,
    children: [
      {
        path: 'list',
        component: () => import('./views/main/articles')
      }
    ]
  },
  {
    path: '/order',
    component: Layout,
    children: [
      {
        path: 'renjuan',
        component: () => import('./views/renjuan/detail')
      },
      {
        path: 'xingshan',
        component: () => import('./views/xingshan/index')
      }
    ]
  },
  {
    path: '/lifo',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('./views/lifo/index')
      },
      {
        path: 'smlist',
        component: () => import('./views/lifo/smlist')
      },
      {
        path: 'shenming',
        component: () => import('./views/lifo/shenming')
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('./views/user/index')
      },
      {
        path: 'yigong',
        component: () => import('./views/user/yigong')
      }
    ]
  }
]
const router = createRouter({
  history: createWebHistory(),
  routes: routerMap
})
export default router
